import { useCallback } from "react"
import { useQuery } from "@tanstack/react-query"

import { fetchSponsoredContent } from "services/venue"
import { IRecord } from "interfaces"

import { prepareSponsoredContent } from "./utils/prepareSponsoredContent"
import {
  EventData,
  ISponsoredContent,
  PromotionData,
  ImdfFeature,
} from "providers/venue/types"
import { useGetAppConfig } from "../app-config/useGetAppConfig"

interface IuseGetSponsoredContentsProps {
  imdfFeatures: ImdfFeature[]
  promotions: PromotionData[]
  events: EventData[]
}

export const useGetSponsoredContents = ({
  imdfFeatures = [],
  promotions = [],
  events = [],
}: IuseGetSponsoredContentsProps) => {
  const { data: appConfig } = useGetAppConfig()
  const sponsoredContentConfig = appConfig.sponsoredContentConfig

  const findOne = useCallback(
    (id: string) =>
      [...imdfFeatures, ...promotions, ...events].find((f) => f.id === id),
    [imdfFeatures, promotions, events]
  )

  return useQuery<IRecord[], unknown, ISponsoredContent>({
    queryKey: ["sponsored-contents"],
    queryFn: async () => {
      const sponsoredContents = await fetchSponsoredContent()
      return sponsoredContents
    },
    placeholderData: [],
    select: (data: IRecord[]): ISponsoredContent =>
      prepareSponsoredContent(data, sponsoredContentConfig, findOne),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
